import s from "./index.module.css";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  gameOffersUpdate,
  gameModeUpdate,
  addGameOffers,
} from "../../../store/slices/gammaSlice";
import gamesService from "../../../api/games/GamesService";
import Swal from "sweetalert2";
import { setGamesErrors } from "../../../store/slices/errors";
import HandleRequests from "../../Shared/handleRequests/HandleRequests";
import ViewListIcon from "@mui/icons-material/ViewList";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import WebStoriesIcon from "@mui/icons-material/WebStories";
import { useTranslation } from "react-i18next";

//material
import {
  Box,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  ToggleButton,
  ToggleButtonGroup,
  Avatar,
} from "@mui/material";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";

const example = {
  id: 999,
  name: "",
  image: "",
  instant: true,
  lottery: {
    id: 8,
    name: "Buenos Aires4",
  },
  modes: [
    {
      id: 0,
      name: "",
    },
  ],
};

export const GamesLogos = () => {
  const [count, setCount] = useState(50);
  const [games, setGames] = useState([]);
  const [display, setDisplay] = useState("list");
  const logos = useSelector((state) => state.gamma?.gameOffers);
  const gameModeRedux = useSelector((state) => state.gamma?.gameMode?.content);
  const [primaryColor, setPrimaryColor] = useState("");
  //const [secondaryColor, setSecondaryColor] = useState("");
  const [popUpOpen, setpopUpOpen] = useState(false);
  const { uiConfig } = useSelector((state) => state.local);
  const [game, setGame] = useState(example);
  const [gameMode, setGameMode] = useState([]);
  const [instant, setInstant] = useState(true);
  let dispatch = useDispatch();
  const backError = useSelector((state) => state.errors.gamesError);
  const { activeOrganization } = useSelector((state) => state.gamma);
  const { textColor } = useSelector((state) => state.local);

  const [gameOffers, setGameOffers] = useState(false);

  const { t } = useTranslation();

  useEffect(() => {
    if (logos?.length) {
      setGames(logos);
    } else {
      if (!gameOffers) {
        gamesService
          .getGameOffers(1)
          .then((res) => {
            dispatch(setGamesErrors({ error: false }));
            dispatch(gameOffersUpdate(res.content));
            setGameOffers(true);
          })
          .catch((error) => {
            dispatch(setGamesErrors({ error: true, code: error.status }));
          });
      }
    }
  }, [logos, dispatch, activeOrganization?.id, gameOffers]);

  useEffect(() => {
    setPrimaryColor(uiConfig.primary.main);
    //setSecondaryColor(uiConfig.secondary.main);
  }, [uiConfig]);

  const handleCreateGame = (e) => {
    game.id = count;
    const i = count + 1;
    setCount(i);
    Array.from(e.target.files).forEach((file) => {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64 = reader.result;
        let gameUpdate = { ...game, image: base64 };
        //  setGame(gameUpdate)

        dispatch(addGameOffers(gameUpdate));
      };
    });
    setpopUpOpen(false);
  };

  const handleChangeImage = (e, logo) => {
    Array.from(e.target.files).forEach((file) => {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64 = reader.result;
        let gameUpdate = { ...logo, image: base64 };
        let newgames = games.filter((o) => o.id !== logo.id);
        dispatch(gameOffersUpdate({ content: [...newgames, gameUpdate] }));
      };
    });
    setpopUpOpen(false);
  };
  const handleOpenPopUpOpen = () => {
    setpopUpOpen(true);
  };
  const handleCheck = () => {
    setGame({ ...game, instant: !instant });
    setInstant(!instant);
  };

  const handleOpenPopUpClose = () => {
    setpopUpOpen(false);
  };

  const handleTextName = (e) => {
    setGame({ ...game, name: e.target.value });
  };

  const handleDelete = (game) => {
    Swal.fire({
      title: `Estas seguro de que deseas eliminar el ${game?.name}?`,
      text: `Si eliminas al juego ${game?.name} no se podra reveertir el cambio.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: primaryColor,
      cancelButtonColor: "#d33",
      cancelButtonText: "Cancelar",
      confirmButtonText: "Eliminar",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Eliminado.", "Juego eliminado con exito", "success");
        let newgames = games?.filter((o) => o.id !== game.id);
        dispatch(gameOffersUpdate({ content: [newgames.content] }));
      }
    });
  };

  const cellStyles = {
    fontFamily: "Roboto, sans-serif",
    fontSize: ".9rem",
    fontWeight: "400",
    borderBottom: "1px solid rgba(0, 0, 0, 0.455)",
    cursor: "pointer",
  };

  return (
    <Grid container className={s.container}>
      <HandleRequests error={backError} loading={!games?.length}>
        <Grid item container xs={11} className={s.header}>
          <Grid item xs={4} className={s.titleContainer}>
            <WebStoriesIcon sx={{ fontSize: 32, color: "primary.main" }} />
            <h4>{t("gamesLogos")}</h4>
          </Grid>
          <Grid item xs={1.5} className={s.displayItem}>
            <ToggleButtonGroup
              color="primary"
              exclusive
              value={display}
              onChange={(e, v) => setDisplay(v)}
            >
              <ToggleButton value="list">
                <ViewListIcon sx={{ fontSize: 24, color: "primary.main" }} />
              </ToggleButton>
              <ToggleButton value="module">
                <ViewModuleIcon sx={{ fontSize: 24, color: "primary.main" }} />
              </ToggleButton>
            </ToggleButtonGroup>
          </Grid>
        </Grid>
        {display === "module" ? (
          <Grid item xs={11} className={s.gamesContainer}>
            {games?.map((g, i) => (
              <React.Fragment key={i}>
                <Box
                  className={`${s.itemGame} ${g.enabled ? null : s.disabledGame}`}
                >
                  <Box
                    className={s.data}
                    sx={{
                      color: "primary.dark",
                      background:
                        "linear-gradient(0deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6), rgba(255,255,255,0), rgba(255,255,255,0))",
                    }}
                  >
                    <h4>{g.game.name}</h4>
                    <p>{g.game.lottery.name}</p>
                    <Box className={s.options}>
                      <p>{g.enabled ? t("active") : t("inactive")}</p>
                      <Box className={s.icons}>
                        <EditRoundedIcon
                          className={s.icon}
                          sx={{ color: "primary.dark" }}
                          onClick={() => {}}
                        />
                        <DeleteForeverOutlinedIcon
                          className={s.icon}
                          sx={{ color: "#ff3333" }}
                          onClick={() => handleDelete(g)}
                        />
                      </Box>
                    </Box>
                  </Box>
                  <img
                    src={g.game.image}
                    alt={g.game.name}
                    className={s.gameBackground}
                  />
                </Box>
              </React.Fragment>
            ))}
          </Grid>
        ) : (
          <Grid item container xs={11} className={s.dataContainer}>
            <TableContainer className={s.tableContainer}>
              <Table>
                <TableHead sx={{ backgroundColor: "primary.main" }}>
                  <TableCell
                    sx={{
                      color: textColor,
                      fontSize: "18px",
                      fontWeight: 500,
                      fontFamily: "Roboto, sans-Serif",
                    }}
                  >
                    {t("logo")}
                  </TableCell>
                  <TableCell
                    sx={{
                      color: textColor,
                      fontSize: "18px",
                      fontWeight: 500,
                      fontFamily: "Roboto, sans-Serif",
                    }}
                  >
                    {t("name")}
                  </TableCell>
                  <TableCell
                    sx={{
                      color: textColor,
                      fontSize: "18px",
                      fontWeight: 500,
                      fontFamily: "Roboto, sans-Serif",
                    }}
                  >
                    {t("lottery")}
                  </TableCell>
                  <TableCell
                    sx={{
                      color: textColor,
                      fontSize: "18px",
                      fontWeight: 500,
                      fontFamily: "Roboto, sans-Serif",
                    }}
                  >
                    {t("state")}
                  </TableCell>
                  <TableCell
                    sx={{
                      color: textColor,
                      fontSize: "18px",
                      fontWeight: 500,
                      fontFamily: "Roboto, sans-Serif",
                    }}
                  ></TableCell>
                  <TableCell
                    sx={{
                      color: textColor,
                      fontSize: "18px",
                      fontWeight: 500,
                      fontFamily: "Roboto, sans-Serif",
                    }}
                  ></TableCell>
                </TableHead>
                <TableBody>
                  {games?.map((g, i) => (
                    <React.Fragment key={i}>
                      <TableRow>
                        <TableCell
                          sx={{
                            ...cellStyles,
                            backgroundColor:
                              i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                          }}
                        >
                          <Avatar
                            src={g.game.image}
                            sx={{ width: 56, height: 56 }}
                          />
                        </TableCell>
                        <TableCell
                          sx={{
                            ...cellStyles,
                            backgroundColor:
                              i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                          }}
                        >
                          {g.game.name}
                        </TableCell>
                        <TableCell
                          sx={{
                            ...cellStyles,
                            backgroundColor:
                              i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                          }}
                        >
                          {g.game.lottery.name}
                        </TableCell>
                        <TableCell
                          sx={{
                            ...cellStyles,
                            backgroundColor:
                              i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                          }}
                        >
                          {g.enabled ? t("active") : t("inactive")}
                        </TableCell>
                        <TableCell
                          sx={{
                            ...cellStyles,
                            backgroundColor:
                              i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                          }}
                        >
                          <EditRoundedIcon
                            className={s.iconbtn}
                            sx={{ color: "primary.dark" }}
                            onClick={() => console.log(g)}
                          />
                        </TableCell>
                        <TableCell
                          sx={{
                            ...cellStyles,
                            backgroundColor:
                              i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                          }}
                        >
                          <DeleteForeverOutlinedIcon
                            className={s.iconbtn}
                            sx={{ color: "#ff3333" }}
                            onClick={() => handleDelete(g)}
                          />
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        )}
      </HandleRequests>
    </Grid>
  );
};

/*
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="baseline"
      >
        <Grid container item
          direction="row"
          justifyContent="center"
          alignItems="flex-start"
        >
          <h1 className={styles.title}>Juegos y Logos</h1>
          <IconButton sx={{ marginTop: 3 }} onClick={handleOpenPopUpOpen} >
            <WebStoriesIcon color={"primary.main"} sx={{
              fontSize: 60,
              color: primaryColor,
              cursor: "pointer",
            }} />
          </IconButton>
        </Grid>
        <Dialog open={popUpOpen} onClose={handleOpenPopUpClose}>
          <DialogTitle>Nuevo Juego</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Ingrese el nombre del nuevo juego.
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label="Nombre"
              onChange={handleTextName}
              required
              rows={1}
              variant="outlined"
              sx={{ marginTop: 3, width: "100%", backgroundColor: "white" }}
              name="name"
            />
            <FormGroup>
              <FormControlLabel control={<Checkbox name="check" onChange={handleCheck} />} label="Instantaneo" />
            </FormGroup>
            <FormControl fullWidth>
              <InputLabel id="label-mod">Modo de Juego</InputLabel>
              <Select
                labelId="label-mod"
                id="gameMode"
                name="gameMode"
                label="Modo de juego"
                value={gameMode.mode}
              >
                {gameMode?.map((mode) => (
                  <MenuItem key={mode.id} value={mode}>{mode.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleOpenPopUpClose}>Cancel</Button>
            <label htmlFor={"add1"} className={styles.labelUpload}>
              <input
                type="file"
                name="add1"
                onChange={(e) => handleCreateGame(e)}
                id={"add1"}
                className={styles.input1}
              />
              <CloudUploadOutlinedIcon sx={{
                fontSize: 45,
                color: primaryColor,
                cursor: "pointer",
              }} />
            </label>
          </DialogActions>
        </Dialog>
      </Grid>
      <Grid item>
      </Grid>
      <ImageList rowHeight={'auto'} gap={30} >
        <ImageListItem key="Subheader" cols={4} style={{ height: 'auto' }}>
          <ListSubheader component="div"></ListSubheader>
        </ImageListItem>
        {games?.map((game, index) => (
          <ImageListItem key={index}>
            <img src={game.image} alt={game.name} />
            <ImageListItemBar
              title={game.name}
              subtitle={game.name}
              actionIcon={
                <Stack
                  direction="row"
                  justifyContent="center"
                  alignItems="center">
                  <label htmlFor={index} className={styles.labelUpload}>
                    <input
                      type="file"
                      name={game.id}
                      onChange={(e) => handleChangeImage(e, game)}
                      id={index}
                      className={styles.input1}
                    />
                    <CloudUploadOutlinedIcon
                    sx={{
                      color: "secondary.main",
                      fontSize: 50,
                      cursor: "pointer",}} />
                  </label>
                  <IconButton onClick={(() => handleDelete(game))}>
                    <DeleteForeverOutlinedIcon sx={{
                      color: "secondary.main",
                      fontSize: 50,
                      cursor: "pointer",
                    }} />
                  </IconButton>
                </Stack>
              }
            />
          </ImageListItem>
        ))}
      </ImageList>
*/
